import { render, staticRenderFns } from "./villageadd.vue?vue&type=template&id=4f824276&scoped=true&"
import script from "./villageadd.vue?vue&type=script&lang=js&"
export * from "./villageadd.vue?vue&type=script&lang=js&"
import style0 from "./villageadd.vue?vue&type=style&index=0&id=4f824276&lang=stylus&scoped=true&"
import style1 from "./villageadd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f824276",
  null
  
)

component.options.__file = "villageadd.vue"
export default component.exports